export enum State {
  INIT = 'init',

  INTRO = 'intro',

  COMPANY_LEGAL_INFO = 'company-legal-info',
  SEND_COMPANY_LEGAL_INFO = 'send-company-legal-info',

  CAPITAL_INFO = 'capital-info',
  SEND_CAPITAL_INFO = 'send-capital-info',

  HAS_PARTNER = 'has-partner',
  SEND_HAS_NO_PARTNER = 'send-has-partner',

  PARTNER_NAME = 'partner-name',
  SEND_PARTNER_NAME = 'send-partner-name',

  ADDRESS = 'address',

  CERTIFICATE_WARNING = 'certificate-warning',
  SEND_CAPITAL_DEPOSIT_QUESTIONS = 'send-capital-deposit-questions',

  DRAFT_STATUTES = 'draft-statutes',

  DONE = 'done',
  ABORT = 'abort',
}

export enum AddressState {
  INIT = 'init',

  SAME_ADDRESS = 'same-address',
  SEND_SAME_ADDRESS = 'send-same-address',

  COMPANY_ADDRESS = 'company-address',
  SEND_COMPANY_ADDRESS = 'send-company-address',

  DONE = 'done',
}
